import { RouteConfig } from ".."

import { AdminSettingsLayout } from "~/layouts/AdminSettingsLayout"
import { AdminLayout } from "~/layouts/AdminLayout"
import { ROUTER_PATHS } from "../constants"
import Products from "~/components/Admin/Settings/Product/Products"
import Coupons from "~/components/Admin/Settings/Coupons/Coupons"
import AutomatedMessagesForm from "~/components/Admin/Settings/automatedMessages/AutomatedMessagesForm"
import InvoicesSettings from "~/components/Admin/Settings/InvoiceSettings/InvoiceSettings"
import PolicyAndRulesForm from "~/components/Admin/Settings/PoliciesAndRulesForm/PolicyAndRulesForm"

export const adminRoutes: RouteConfig[] = [
  {
    path: ROUTER_PATHS.ADMIN,
    layout: <AdminLayout />,
    routes: [
      {
        layout: <AdminSettingsLayout />,
        path: ROUTER_PATHS.ADMIN_SETTINGS,
        routes: [
          {
            path: ROUTER_PATHS.ADMIN_SETTINGS_PRODUCTS,
            component: <Products />,
          },
          {
            path: ROUTER_PATHS.ADMIN_SETTINGS_INVOICES,
            component: <InvoicesSettings />,
          },
          {
            path: ROUTER_PATHS.ADMIN_SETTINGS_COUPONS,
            component: <Coupons />,
          },
          {
            path: ROUTER_PATHS.ADMIN_SETTINGS_AUTOMATED_MESSAGES,
            component: <AutomatedMessagesForm />,
          },
          {
            path: ROUTER_PATHS.ADMIN_SETTINGS_RULES_TERMS,
            component: <PolicyAndRulesForm />,
          },
        ],
      },
    ],
  },
]
